/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type AgelessAssessmentUsageContext =
  (typeof AgelessAssessmentUsageContext)[keyof typeof AgelessAssessmentUsageContext];

export const AgelessAssessmentUsageContext = {
  Standard: "Standard",
  InClinic: "InClinic",
  Consult: "Consult",
  WebsiteEmbed: "WebsiteEmbed",
} as const;
